import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from 'Components';
import styles from './index.module.css';

export const ReceivingGift = () => {
  const navigate = useNavigate();
  const [showSecondContent, setShowSecondContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSecondContent(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <div className={styles.giftPage}>
      <div
        aria-hidden="true"
        onClick={handleBackClick}
        className={styles.backLink}
      >
        BACK
      </div>
      <div
        aria-hidden="true"
        onClick={() => navigate('/newSign-in')}
        className={styles.loginLink}
      >
        Log In
      </div>
      <div className={styles.giftPageContent}>
        <a href="https://www.projectorstream.com/">
          <Logo className={styles.logo} isLarge isLight />
        </a>

        {!showSecondContent ? (
          <div className={styles.contentContainer}>
            <h1 className={styles.heading}>You Have Received Projector Memories!</h1>
            <h2 className={styles.subHeading}>Layne has gifted you Projector for your Wedding!</h2>

            <p className={styles.description}>
              Projector is where new and old memories lives.
              <span className={styles.desktopBreak}><br /></span>
              This gift is a truly thoughtful and meaningful addition. Your close friends
              {' '}
              <span className={styles.desktopBreak}><br /></span>
              and family want to follow your most special memories and also share theirs with you!
            </p>

            <p className={styles.description}>
              Unlike other cloud storage this is storage you can stream on any device. Forget
              <span className={styles.desktopBreak}><br /></span>
              the digital photo frame you now can stream on and screen and device. Watch
              <span className={styles.desktopBreak}><br /></span>
              your memories like how you watch your movies.
            </p>
          </div>
        ) : (
          <div className={styles.contentContainer}>
            <h1 className={styles.heading}>Your Projector</h1>
            <span className={styles.featureText}>
              Layne has started your projector
              <span className={styles.desktopBreak}><br /></span>
              with a few photos and videos.
            </span>

            <span className={styles.featureText} style={{ marginTop: '71px' }}>
              Start adding files and invite your closest
              <span className={styles.desktopBreak}><br /></span>
              friends and family so they can see. You can always keep
              <span className={styles.desktopBreak}><br /></span>
              everything private and secure as well.
            </span>

            <button className={styles.startGiftButton}>
              Are you Ready to See It?
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReceivingGift;
